import Typography from '@mui/material/Typography';
import { useTheme } from "@mui/material";


export default function TextCardPipe({ textcard }) {

    const theme = useTheme();
    const parts = textcard.split('|')
   
    return (

        theme.palette.mode === "light" ? (
               

<>
      {parts.map((part, index) => (
        <Typography variant="subtitle2" color= 'common.black' key={index}>
          {part}
          {index < parts.length - 1 && <br />}
          </Typography>
      ))}
</>

  ) : (

<>
      {parts.map((part, index) => (
        <Typography variant="subtitle2" color= 'common.white' key={index}>
          {part}
          {index < parts.length - 1 && <br />}
          </Typography>
      ))}
 </>
    )
)
}